export default "__VITE_PUBLIC_ASSET__0d308303__"